export const requestTypes = {
  1: "Leave",
  2: "Long Break",
  3: "CheckIn Adjustment",
  4: "CheckOut Adjustment",
  5: "Overtime",
  6: "Breaks Adjustment",
  7: "Half Day",

};

export const status = {
  1: "Pending",
  2: "Reject",
  3: "Approve",
};

export const rembursment = {
  1: "OPD",
  2: "Maternity",
  3: "Hospitalization",
};
export const months = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

export const breaks = {
  Official: {
    id: 1,
    src: require("../assets/img/official.png"),
    reasons: [
      { id: 1, label: "Meeting" },
      { id: 2, label: "Boss" },
      { id: 3, label: "Administrator" },
    ],
  },
  Prayer: {
    id: 2,
    src: require("../assets/img/prayer.png"),
    reasons: [
      { id: 4, label: "Asr" },
      { id: 5, label: "Maghrib" },
      { id: 6, label: "Isha" },
    ],
  },
  Personal: {
    id: 3,
    src: require("../assets/img/persnol.png"),
    reasons: [
      { id: 7, label: "Dinner" },
      { id: 8, label: "Smoking" },
      { id: 9, label: "Away" },
      { id: 10, label: "Other" },
    ],
  },
};

export const changes = [
  
  { id: 1, key: "Deductions", label: "Deductions" },
  { id: 2, key: "Overtime", label: "Overtime" },
  { id: 3, key: "YearlyBonus", label: "Yearly Bonus" },
  { id: 4, key: "MonthlyBonus", label: "Monthly Bonus" },
  { id: 5, key: "EmployeeLoan", label: "Employee Loan" },
  { id: 6, key: "OtherBonus", label: "Other Bonus" },
  { id: 7, key: "ExternalProject", label: "External Project" },
  { id: 8, key: "Reimbursement", label: "OPD" },
  { id: 9, key: "MiscPayments", label: "Misc Payments" },
];

export const transformedBreaks = Object.keys(breaks).reduce((acc, key) => {
  const breakItem = breaks[key];
  acc[breakItem.id] = key;
  return acc;
}, {});
